import { Box } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";

export const Wrapper = styled(Box)`
    position: fixed;
    z-index: 1000;
    width: 109px;
    box-sizing: border-box;
`